import { Route, Routes } from 'react-router';
import PermissionRoute from 'src/permission/permissionRoute';
import { useParams } from 'react-router-dom';
import buildAccess from 'src/permission/buildAccess';
import { travelTypeObject } from 'src/enumeration';
import Enum from './enum';
import List from './List';

const BankSystemManagement = () => {
  const urlParams = useParams();
  const access = buildAccess(Enum.routes.name, travelTypeObject[urlParams.type]?.type);

  return (
    // <div>{'hiiii'}</div>
    <Routes>
      <Route
        path={`${Enum.routes.list}`}
        element={<PermissionRoute element={<List access={access} />} permissions={access?.read} />}
      />
    </Routes>
  );
};

export default BankSystemManagement;
